import React, { useState, useEffect, Fragment } from "react";
import "./FileManagement.css";
import Sidebar from "../../components/Sidebar";
import AsignedHeader from "./AsignedHeader.js";
import { useSelector, useDispatch } from "react-redux";
import { FaPencilAlt, FaStreetView, FaUserAlt, FaUserPlus } from "react-icons/fa";
import { GrUpdate, GrView } from "react-icons/gr";
import { DataGrid } from "@mui/x-data-grid";
import {
  getStudentsData,
  getAsignedApplications,
} from "../../actions/fileAction";
import { toast } from "react-toastify";
import { clearError } from "../../actions/fileAction";
import Loading from "../../components/Loading/loading";
import { Link, useNavigate } from "react-router-dom";
import MetaData from "../../components/MetaData";
import NoDataFound from "../../components/NoDataFound";
import { AiFillEye } from "react-icons/ai";
import Pagination from "react-js-pagination";
// import { Link } from "@mui/material";

// Modal.setAppElement('#yourAppElement');

const AsignedApplication = ({ underLine, setUnderLine }) => {
  setUnderLine("ass-management");

  const [searchWord, setSearchWord] = useState("");
  const [CurrentPage, setCurrentPage] = useState(1)

  const dispatch = useDispatch();
  const { error, students,resultPerPage,totalfilterStudents, loading } = useSelector(
    (state) => state.asignApplications
  );
  const {
    error: userError,
    user,
    loading: userLoading,
  } = useSelector((state) => state.users);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error]);

  useEffect(() => {
    searchHandler();
    // dispatch(getAsignedApplications(user._id))
  }, [CurrentPage]);

  const Navigate = useNavigate();

  useEffect(() => {
    if(user?.role !== 'admin' && user?.role !== 'lead-counsellor' && user?.role !== 'counsellor' ){
      Navigate('/dashboard')
    }
  }, [user])

  const columns = [
    { field: "id", headerName: "S No.", minWidth: 80, flex: 0.5 },

    {
      field: "name",
      headerName: "Name",
      minWidth: 200,
      flex: 0.5,
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 220,
      flex: 0.5,
    },
    {
      field: "phone",
      headerName: "Phone",
      minWidth: 220,
      flex: 0.5,
    },
    {
      field: "course",
      headerName: "Course",
      minWidth: 150,
      flex: 0.5,
    },
    {
      field: "country",
      headerName: "Country",
      minWidth: 150,
      flex: 0.5,
    },

    {
      field: "createAt",
      headerName: "Create At",
      minWidth: 200,
      flex: 0.5,
      // cellClassName: (params) => {
      //   return (params.getValue(params.id, "role"))
      // },
    },
    {
      field: "actions",
      headerName: "Actions",
      type: "number",
      minWidth: 240,
      flex: 0.3,
      sortable: false,
      renderCell: (params) => {
        // console.log("dsf",params.row.id_);
        return (
          <Fragment className="actionIconBox">
            <Link
              to={`/student/details/${params.row.id_}`}
              className="student-icons"
            >
             <AiFillEye/>
              </Link>
            <Link
              to={`/student/details/update/${params.row.id_}`}
              className="student-icons"
            >
              <FaPencilAlt />
            </Link>
            {/* <Link className="student-icons"to={`/student/asign/${params.id}`} >
            <FaUserPlus/>
          </Link> */}
          </Fragment>
        );
      },
    },
  ];

  const rows = [];

  students &&
    students.forEach((item,i) => {
      let date = new Date(item?.createdAt)

      rows.push({
        id_: item._id,
        id: i+1,
        name: item.Name,
        email: item.Email,
        phone: item.Phone,
        country: item.Country,
        course: item.Course,
        createAt:date.toString().split('G')[0]
      });
    });

  // modal code



  const searchHandler = (e) => {
    dispatch(getAsignedApplications(user?._id, searchWord,CurrentPage));
  };

  return (
    <div className="dashboardMain">
      <MetaData title={"Application Management"}/>

      <div
        className={
          window.innerWidth > 600 ? "menuContainer show" : "menuContainer hide"
        }
      >
        <Sidebar underLine={underLine} />
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="dashboardContainer">
          <AsignedHeader heading={"Application"} />

          <div className="D-ButtonLayer">
            <div className="BlRow1">
              <div className="BlItem ">
                <div>
                  <p>Total Applications</p>
                  <p>{totalfilterStudents && totalfilterStudents}</p>
                </div>
                <div className="BlItem4">
                  <FaUserAlt />
                </div>
              </div>

              <div className="student-search-box">
                <form action="" onSubmit={searchHandler}>
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchWord}
                    onChange={(e) => setSearchWord(e.target.value)}
                  />
                  <input type="submit" value={"Search"} />
                </form>
              </div>
            </div>
          </div>
          {
            rows.length !== 0 ? (<div className="usersContainer">
            <DataGrid
              rows={rows}
              columns={columns}
              pageSize={20}
              disableSelectionOnClick
              className="usersTable"
              // autoHeight
              autoWidth
              rowHeight={65}
              sx={{
                fontSize: 19,
                backgroundColor: "white",
                boxShadow: 2,
                fontFamily: "Roboto",
                color: "black",
                //   headerColor: 'black',
                padding: 0,
                "& .MuiDataGrid-cell:hover": {
                  color: "primary.main",
                },
              }}
            />
             {
      totalfilterStudents > resultPerPage &&
          <div className="paginationContainer">
            <Pagination
              activePage={CurrentPage}
              itemsCountPerPage={resultPerPage}
              totalItemsCount={totalfilterStudents}
              onChange={e=>setCurrentPage(e)}

              className="paginationBox"

              // prevPageText="<"
              firstPageText="1st"
              lastPageText="Last"
              // nextPageText=">"
              itemClass='page-item'
              linkClass='page-link'
              activeClass='pageItemActive'
              activeLinkClass='pageLinkActive'
            />
          </div>
          }
          </div>):<NoDataFound/>
          }


        </div>
      )}
    </div>
  );
};

export default AsignedApplication;
